<h2 mat-dialog-title>Error</h2>
<mat-dialog-content class="error">{{data.errorMsg}}</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button (click)="closeDialog()">Ok</button>
</mat-dialog-actions>